import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { lazy } from 'react';
import { getSubscriptionAction } from '../../../api/action/subscription.action';
import { QUERY_KEY } from '../../../api/types/query.type';
import Loader from '../../UIcomponents/Loader';
import { isValidSubscription } from './helpers.subscription';
import { theme } from './theme';
var SubscriptionInfo = lazy(function () { return import('./SubsInfo'); });
var OrderSubscription = lazy(function () { return import('./OrderSubscription'); });
var Heading = lazy(function () { return import('../../UIcomponents/Heading'); });
var Subscription = function () {
    var _a = useQuery({
        queryKey: [QUERY_KEY.GET_SUBSCRIPTION],
        queryFn: getSubscriptionAction,
    }), subscription = _a.data, isLoadingSubscription = _a.isLoading;
    if (isLoadingSubscription) {
        return (_jsxs(Paper, { children: [_jsx(Heading, { title: "subscription.title" }), _jsx(Loader, {})] }));
    }
    return (_jsxs(Paper, { sx: theme.container, children: [_jsx(Heading, { title: "subscription.title" }), !isValidSubscription(subscription.expirationDate) ? (_jsx(OrderSubscription, {})) : (_jsx(SubscriptionInfo, { expirationDate: subscription.expirationDate, subscriptionName: subscription.name }))] }));
};
export default Subscription;
